export const UPDATE_INSURANCES = 'UPDATE_INSURANCES'
export const UPDATE_INSURANCES_WITH_CALENDAR_INDEX = 'UPDATE_INSURANCES_WITH_CALENDAR_INDEX'
export const UPDATE_INSURANCES_FOR_PRACTICES_WITH_ONE_PROVIDER = 'UPDATE_INSURANCES_FOR_PRACTICES_WITH_ONE_PROVIDER'
export const UPDATE_REASONS = 'UPDATE_REASONS'
export const UPDATE_TIME_BLOCKS = 'UPDATE_TIME_BLOCKS'
export const UPDATE_FIELD_SETTINGS = 'UPDATE_FIELD_SETTINGS'
export const UPDATE_CALENDAR_DETAILS = 'UPDATE_CALENDAR_DETAILS'
export const UPDATE_CALENDAR_INSURANCES = 'UPDATE_CALENDAR_INSURANCES'
export const UPDATE_CALENDAR_REASONS = 'UPDATE_CALENDAR_REASONS'
export const UPDATE_CALENDAR_TEXT = 'UPDATE_CALENDAR_TEXT'
export const UPDATE_CALENDAR_SCREENING_SETTINGS = 'UPDATE_CALENDAR_SCREENING_SETTINGS'
export const UPDATE_CREATED_APPOINTMENT = 'UPDATE_CREATED_APPOINTMENT'
export const RESET_CREATED_APPOINTMENT = 'RESET_CREATED_APPOINTMENT'
export const REMOVE_CALENDAR = 'REMOVE_CALENDAR'
export const SAVE_CALENDAR_ID = 'SAVE_CALENDAR_ID'
export const CLEAR_SAVED_CALENDARS_IDS_LIST = 'CLEAR_SAVED_CALENDARS_IDS_LIST'
export const CLEAR_CALENDARS = 'CLEAR_CALENDARS'
export const INIT_CALENDARS = 'INIT_CALENDARS'
export const UPDATE_CALENDAR_ID = 'UPDATE_CALENDAR_ID'
export const UPDATE_CALENDAR_LABEL = 'UPDATE_CALENDAR_LABEL'
export const ADD_ITEM_TO_A_QUEUE = 'ADD_ITEM_TO_A_QUEUE'
export const SET_RESPONSE_CALLBACK_TO_ITEM_IN_A_QUEUE = 'SET_RESPONSE_CALLBACK_TO_ITEM_IN_A_QUEUE'
export const SET_QUEUE_ITEM_IS_PROCESSED = 'SET_QUEUE_ITEM_IS_PROCESSED'
export const CLEAR_REQUEST_QUEUE = 'CLEAR_REQUEST_QUEUE'
export const UPDATE_CALENDAR_PHONE_NUMBERS = 'UPDATE_CALENDAR_PHONE_NUMBERS'
export const SET_APPOINTMENT_TYPES = 'SET_APPOINTMENT_TYPES'
export const SET_APPOINTMENT_TYPES_ENABLED = 'SET_APPOINTMENT_TYPES_ENABLED'
export const SET_GOOGLE_MAPS_API_KEY = 'SET_GOOGLE_MAPS_API_KEY'

export const SAVE_CALENDARS = 'SAVE_CALENDARS'
export const SAVE_LOCATIONS = 'SAVE_LOCATIONS'
export const SAVE_PROVIDERS = 'SAVE_PROVIDERS'
export const SAVE_ALL_DOC_LOCS = 'SAVE_ALL_DOC_LOCS'
export const SAVE_INIT_CALENDARS_INFO = 'SAVE_INIT_CALENDARS_INFO'
export const SAVE_CALENDAR_INDEX_TO_LOCATION_AND_PROVIDER_MAP = 'SAVE_CALENDAR_INDEX_TO_LOCATION_AND_PROVIDER_MAP'
export const SAVE_CALENDAR_ID_TO_INDEX_MAP = 'SAVE_CALENDAR_ID_TO_INDEX_MAP'
